export default __webpack_public_path__ + "media/images/nearbyPlaces/convenience_store-2dc42769b2d18bdd874d23d21cb1f704.png";